import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate, query } from '../../lib/loopback'

const configuracoesRepository = createRepository({
  path: 'configuracoes',
  restApi,
  queryTransform: {
    chave: query.ilike('chave'),
    ...paginate
  }
})

export default configuracoesRepository
